<script setup lang="ts">
// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "flex";
  }>(),
  {
    type: "flex"
  }
);

const style: Record<string, string> = {};

function setStyle() {
  switch (props.type) {
    case "flex":
    default:
      style.display = "flex";
      style.flexDirection = "column";
      style.justifyContent = "flex-start";
      style.alignItems = "center";
  }
}
setStyle();

defineExpose({});
</script>

<template>
  <div
    class="content-top-center"
    :style="style"
  >
    <slot></slot>
  </div>
</template>
